var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRotateCcw = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  fillRule: "evenodd",
  clipPath: "url(#rotate-ccw_svg__a)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.667 2.789c.368 0 .666.298.666.667v3.333h3.334a.667.667 0 1 1 0 1.333h-4A.667.667 0 0 1 0 7.456v-4c0-.369.298-.667.667-.667Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.07 2.193a6.666 6.666 0 1 1-5.359 8.817.667.667 0 0 1 1.258-.443 5.333 5.333 0 1 0 1.248-5.532L1.123 7.94A.667.667 0 0 1 .21 6.97l3.086-2.9A6.667 6.667 0 0 1 7.07 2.193Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "rotate-ccw_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .789h16v16H0z"
})))));
SvgRotateCcw.viewBox = '0 0 16 17';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRotateCcw);
export default ForwardRef;